import {useEffect, useMemo, useRef} from 'react';
import {useGetCartQuery} from 'modules/cart/services';
import {ICartProduct} from 'modules/cart/models';
import {getFlocktoryInstance} from 'core/helpers';
import {useGetUserQuery} from 'modules/user/services';

interface IFlocktoryCartItem {
    id: string;
    price: number;
    count: number;
}

const updateFlocktoryCart = (items: IFlocktoryCartItem[]): void => {
    try {
        const flocktory = getFlocktoryInstance();
        flocktory.push([
            'updateCart',
            {
                cart: {items},
            },
        ]);
    } catch {}
};

const transformCartItems = (products: ICartProduct[] = []): IFlocktoryCartItem[] => {
    return products.map((product) => ({
        id: String(product.offerId),
        price: product.price?.discount?.price || product.price?.base?.price || 0,
        count: product?.cartData?.quantity || 0,
    }));
};

export const useSyncCartFlocktory = (): void => {
    const {data: user} = useGetUserQuery();
    const {data: cartData, isFetching: isCartLoading} = useGetCartQuery({
        mini: true,
    });

    const hasSyncedCartRef = useRef(false);

    const cartItems = useMemo(() => transformCartItems(cartData?.products), [cartData?.products]);

    useEffect(() => {
        if (isCartLoading || hasSyncedCartRef.current) {
            return;
        }

        updateFlocktoryCart(cartItems);
        hasSyncedCartRef.current = true;
    }, [user?.isAuthorized, isCartLoading, cartItems]);
};

export const clearFlocktoryCart = (): void => {
    updateFlocktoryCart([]);
};
